import React, { useEffect, useState } from 'react';
import { joinPublicStorefrontUrl } from '../../api/client';
import './AnnouncementBar.css';

let _cache = null;
let _cacheTs = 0;
const CACHE_MS = 60_000;

async function fetchAnnouncement() {
  if (_cache && Date.now() - _cacheTs < CACHE_MS) return _cache;
  try {
    const res = await fetch(joinPublicStorefrontUrl('/api/announcement'), { cache: 'no-store' });
    if (!res.ok) return null;
    _cache = await res.json();
    _cacheTs = Date.now();
    return _cache;
  } catch {
    return null;
  }
}

const SPEED_DURATION = { slow: '40s', normal: '24s', fast: '12s' };

export default function AnnouncementBar() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    fetchAnnouncement().then((data) => {
      if (data && data.enabled && data.text) setAnn(data);
    });
  }, []);

  if (!ann) return null;

  const duration = SPEED_DURATION[ann.speed] || SPEED_DURATION.normal;
  const content = ann.link
    ? <a href={ann.link} className="ann-bar__link">{ann.text}</a>
    : <span>{ann.text}</span>;

  return (
    <div
      className="ann-bar"
      style={{ '--ann-bg': ann.bg_color, '--ann-color': ann.text_color, '--ann-duration': duration }}
    >
      <div className="ann-bar__track" aria-live="polite">
        {/* Duplicate text so marquee loops seamlessly */}
        <span className="ann-bar__content" aria-hidden="false">{content}</span>
        <span className="ann-bar__content" aria-hidden="true">{content}</span>
        <span className="ann-bar__content" aria-hidden="true">{content}</span>
      </div>
    </div>
  );
}
